<h1 mat-dialog-title>
  <span *ngIf="data.action === 'new'">{{ 'common.words.new' | translate }} - </span>
  {{ data.modalTitle }}
</h1>
<ng-container class="digital-document-wrapper" *ngIf="!docType && !docUploaded">
  <div class="row p-5">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center mb-4">
          {{ 'properties.addDocumentsPage.docTypes.chooseMessage' | translate }}
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button class="mr-2 mb-2" mat-stroked-button (click)="onChooseDocType('digital')" color="primary">
            {{ 'properties.addDocumentsPage.docTypes.digital' | translate }}
            <mat-icon fontSet="fal" fontIcon="fa-desktop"></mat-icon>
          </button>
          <button mat-stroked-button (click)="onChooseDocType('paper')" color="accent">
            {{ 'properties.addDocumentsPage.docTypes.paper' | translate }}
            <mat-icon fontSet="fal" fontIcon="fa-scroll"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="text-left w-100">
        <a mat-button (click)="onClose()" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="docType && !docUploaded">
  <mat-dialog-content>
    <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

    <div class="form-wrapper mt-3">
      <!-- Same-code edit: the rows the form is saved on, after a partial save the unwritten ones marked -->
      <div class="row mb-3" *ngIf="sameCodeTargets.length">
        <div class="col-12">
          {{ 'properties.dialog.docEditSameCodeTargets' | translate }}
          <ul class="mb-0 mt-1">
            <li *ngFor="let target of sameCodeTargets">
              {{ target.label }}
              <span class="text-danger" *ngIf="sameCodeFailed[target.subDocId]">
                – {{ 'properties.dialog.docEditSameCodeNotSaved' | translate }}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="row mb-2" *ngIf="data.action !== 'new'">
        <div class="col-6 pt-2" *ngIf="qrcodeData !== ''">
          <div class="qrcode">
            <qrcode #qrdata [qrdata]="qrcodeData" [width]="200" [errorCorrectionLevel]="'H'" [elementType]="url">
            </qrcode>
          </div>
          <mat-icon color="primary" fontSet="fas" fontIcon="fa-download" class="icon-action mt-3"
            matTooltip="Salva QR code" (click)="onSaveQRAsImage(qrdata)">
          </mat-icon>

        </div>
        <div class="col-6">
          <div *ngFor="let item of pdfMsgUrl">
            <a href="{{ item.url }}" target="_blank" matTooltip="{{ 'common.cta.open_new_tab' | translate }}"
              *ngIf="contract">
              <mat-icon fontSet="fal" fontIcon="fa-envelope"></mat-icon>
              {{ 'common.cta.contract_pdf_msg' | translate }} {{ item.sent | date}}
            </a>
          </div>
        </div>
      </div>
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
        <div class="row mb-1">
          <div class="col-12" *ngFor="let item of existingNotes">
            <div class="note-preview-box">
              <div class="created-at" title="{{ item.createdAt }}">
                {{ item.createdAt | date }} - {{ item.createdBy }}
              </div>
              <div class="text">{{ item.text }}</div>
            </div>
          </div> <!-- /.col -->
        </div> <!-- ./row -->
        <div class="row mb-5" *ngIf="data.action !== 'new'">
          <app-card-spinner [visible]="!userDataSetted || !userData" type="zero"></app-card-spinner>
          <div class="col-12" *ngIf="userDataSetted && userData && (userData.createdBy._id || userData.createdAt)">
            <app-creator-updator-box [data]="userData"></app-creator-updator-box>
            <!-- <div class="my-label">{{ 'common.createdAt' | translate }}</div>
          <div class="text mb-2">{{ data.itemData.createdAt | date }}</div>
          <div class="my-label">{{ 'common.createdBy' | translate }}</div>
          <div class="text">{{ data.itemData.createdBy }}</div> -->
          </div> <!-- /.col -->
        </div> <!-- ./row -->
      </form>
    </div> <!-- /.form-wrapper -->
  </mat-dialog-content> <!-- mat-dialog-content -->
  <div class="col-12 pb-4" mat-dialog-actions>
    <div class="col-6 text-left">
      <div class="w-100">
        <a mat-button (click)="onClose()" mat-raised-button mat-default [disabled]="sameCodeSaving"
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
    <div class="col-6 text-right">
      <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions" class="btn-elevate"
        *ngIf="data.action === 'edit' || data.action === 'new'">
      </mat-spinner-button>
    </div>
  </div>
</ng-container>

<ng-container class="digital-document-wrapper" *ngIf="docType && docUploaded">
  <div class="row p-5">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center mb-4">
          {{ 'properties.addDocumentsPage.docTypes.successMessage' | translate }}
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <mat-spinner-button (btnClick)="onPrint('module')" [options]="printModuleBtnOptions" class="btn-elevate">
          </mat-spinner-button>
          <mat-spinner-button (btnClick)="onPrint('qr')" [options]="printQrBtnOptions" class="btn-elevate ml-2">
          </mat-spinner-button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="text-left w-100">
        <a mat-button (click)="onClose({ save: 'success' })" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
  </div>
</ng-container>